import Provider, {ApiProvider, ProviderFilters} from '@/model/Provider';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {parseGenericFilters} from '../meta/filters';


export enum ResourceKunde {
  Kunde = '/Kunde',
}

export async function getProviders(
    filters: ProviderFilters,
): Promise<CombinedApiResponse<Provider[]>> {
  const response = await doApiRequest<ApiProvider[]>({
    method: Method.Get,
    resource: ResourceKunde.Kunde,
    module: Module.Kunde,
    filters: parseGenericFilters(filters),
  });

  return [response.Data.map((p) => Provider.fromApi(p)), response.CountAll];
}
